import { toast } from 'react-toastify';

// it might be smarter to inline this as it is imported on the top level so
// vendor.css will be loaded right away on every load
import('@/styles/vendor.css');

export { toast };
